export default __webpack_public_path__ + "static/media/img_mywheelbox_logotype.31b56337.png";